/* eslint-disable */
export class MarkerComment {
  comment: string;
  created_at: number;
  owner: string;
  }
